import Logo from '../../../images/logo.png'

export const navbarData = (romana: boolean) =>  ({
  logo: Logo,
  labels: [
    {
      "ro": "Acasa",
      "de": "Home",
      link: romana ? "https://agapewien.at/ro/#navbar" : "https://agapewien.at/de/#navbar"
    },
    {
      "ro": "Despre Noi",
      "de": "Über uns",
      link: romana ? "https://agapewien.at/ro/#about" : "https://agapewien.at/de/#about"
    },
    {
      "ro": "Live",
      "de": "Live",
      link: romana ? "https://agapewien.at/ro/#live" : "https://agapewien.at/de/#live"
    },
    {
      "ro": "Doneaza",
      "de": "Spenden",
      link: romana ? "https://agapewien.at/ro/#donate" : "https://agapewien.at/de/#donate"
    },
    {
      "ro": "Contact",
      "de": "Impressum",
      link: romana ? "https://agapewien.at/ro/#impressum" : "https://agapewien.at/de/#impressum"
    }
  ]
});
